import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CameraGridOutlineSVG = function CameraGridOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27,2H5A3,3,0,0,0,2,5V27a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V5A3,3,0,0,0,27,2Zm1,3v5.68H21.33V4H27A1,1,0,0,1,28,5ZM12.67,19.33V12.67h6.66v6.66Zm6.66,2V28H12.67V21.33Zm-8.66-2H4V12.67h6.67Zm2-8.66V4h6.66v6.67Zm8.66,2H28v6.66H21.33ZM5,4h5.68v6.67H4V5A1,1,0,0,1,5,4ZM4,27V21.33h6.67V28H5A1,1,0,0,1,4,27Zm23,1H21.33V21.33H28V27A1,1,0,0,1,27,28Z"
  }));
};
CameraGridOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CameraGridOutlineSVG);